export const Constants = {
    Repay: {
        EmptyField: 'Field is empty',
        TimeOut: 'We are sorry! We are currently experiencing difficulty in reaching our payment vendor. Please try again soon'
    },
    FileName:{
        AgreementPolicies: 'Agreement',
        Invoice:'Invoice',
        ServiceAgreement:'Service-Agreement',
        TransactionDetail:'Transaction'
    },
    TrimControls:{
        CompanyName:'CompanyName',
        MailingAddress:'MailingAddress',
        MailingCity:'MailingCity',
        PhysicalAddress: 'PhysicalAddress',
        PhysicalCity: 'PhysicalCity',
        TypeOfWork: 'TypeOfWork',
        OilAndGasOperatorCompanyNames: 'OilAndGasOperatorCompanyNames',
        SubContractorCompanyNames: 'SubContractorCompanyNames',
        HearAboutPTCOther: 'HearAboutPTCOther',
        DerName: 'DerName',
        DerTitle: 'DerTitle',
        DerAlternateName: 'DerAlternateName',
        BillingContactName: 'BillingContactName',
        BillingAddress: 'BillingAddress',
        BillingCity: 'BillingCity',
        OtherBillingContactName: 'OtherBillingContactName',
        LisOfAuditors: 'LisOfAuditors',
        DotEmployeeTitle: 'DotEmployeeTitle',
        NonDotEmployeeTitle: 'NonDotEmployeeTitle',
        OtherProgramOtherName: 'OtherProgramOtherName',
        CompanyRepresentativeName: 'CompanyRepresentativeName',
        ITSAccountNo: 'ITSAccountNo',
        DerEmail: 'DerEmail',
        AlternateDerEmail: 'AlternateDerEmail',
        OtherBillingContactEmail: 'OtherBillingContactEmail',
        DerExtension: 'DerExtension',
        AlternateDerExtension: 'AlternateDerExtension',
        BillingContactEmail :'BillingContactEmail'
    }
}